<template>
  <div>
    <special-index v-show="special && special['index/index']" :page-path="'index/index'" :item-id="''"></special-index>
    <div class="container b2b-home" v-show="!special || !special['index/index']">
      <section class="home-hero">
        <div class="hero-banner" v-if="banners && banners.length > 0">
          <index-banner :items="banners"></index-banner>
        </div>
        <div class="hero-fallback" v-else>
          <div class="hero-copy">
            <span>Global wholesale marketplace</span>
            <strong>Source, sell, and shop in one platform</strong>
          </div>
        </div>
      </section>

      <section class="channel-shell">
        <div class="channel-tabs">
          <button
            type="button"
            :class="{ active: activeHomeTab === 'products' }"
            @click="activeHomeTab = 'products'"
          >Products</button>
          <button
            type="button"
            :class="{ active: activeHomeTab === 'manufacturers' }"
            @click="activeHomeTab = 'manufacturers'"
          >Manufacturers</button>
        </div>

        <div class="tab-panel" v-show="activeHomeTab === 'products'">
          <div class="product-search-wrap">
            <div class="channel-search product-search" @click="goRoute('HomeSearch', { fromHome: '1' }, { isFromHome: true })">
              <span>Search products, deals, and categories</span>
              <i class="iconfont search-submit">&#xe689;</i>
            </div>
          </div>

          <div class="action-scroll">
            <div
              class="action-card"
              v-for="item in productActions"
              :key="item.title"
              @click="goRoute(item.routeName, item.query, item.params)"
            >
              <i v-if="item.iconClass" :class="[item.color, item.iconClass]"></i>
              <i v-else class="iconfont" :class="item.color" v-html="item.icon"></i>
              <strong>{{ item.title }}</strong>
            </div>
          </div>

          <index-menu :items="navs"></index-menu>

          <index-floor-ads v-if="floorAds" :ad="floorAds[0]"></index-floor-ads>

          <index-seckill-list
            :items="goodSeckill"
            v-if="goodSeckill && goodSeckill.length > 0"
          ></index-seckill-list>

          <index-product-list
            :items="goodProducts"
            title="Popular recommendation"
            :type="popular"
            v-if="goodProducts && goodProducts.length > 0"
          ></index-product-list>

          <index-floor-ads v-if="floorAds" :ad="floorAds[1]"></index-floor-ads>

          <index-product-scroll></index-product-scroll>
        </div>

        <div class="tab-panel" v-show="activeHomeTab === 'manufacturers'">
          <div class="manufacturer-search-area">
            <div class="channel-search manufacturer-search" @click="goRoute('HomeSearch', { type: 'suppliers', fromHome: '1' }, { isFromHome: true })">
              <span>Search manufacturers and stores</span>
              <i class="iconfont search-submit">&#xe689;</i>
            </div>

            <div class="manufacturer-cats">
              <span
                v-for="item in manufacturerCategories"
                :key="item.id"
                :class="{ active: item.active }"
                @click="goStoreCategory(item.id)"
              >{{ item.title }}</span>
            </div>
          </div>

          <section class="manufacturer-section">
            <div class="section-title">
              <div>
                <span>Manufacturer discovery</span>
                <strong>Get samples</strong>
              </div>
              <button type="button" @click="goRoute('HomeGoodslist', { is_sample: 1 })">More</button>
            </div>
            <div class="sample-scroll">
              <div
                class="sample-card"
                v-for="item in manufacturerSamples"
                :key="item.goods_id"
                @click="goGoodsDetail(item.goods_id)"
              >
                <img v-lazy="item.goods_image_url || item.goods_img_480 || item.goods_image_format">
                <span>{{ item.goods_name }}</span>
                <strong>${{ item.sample_price }}</strong>
              </div>
            </div>
          </section>

          <section class="manufacturer-section">
            <div class="section-title manufacturer-ranking-title">
              <strong>Top-ranking manufacturers</strong>
            </div>
            <common-store-list
              :sort-key="'store_sales'"
              :compact="true"
              :horizontal="true"
              :limit="10"
              :logo-only="true"
              :only-with-goods="true"
            ></common-store-list>
          </section>

          <section class="manufacturer-section manufacturer-suppliers-section">
            <div class="section-title">
              <strong>Featured suppliers</strong>
            </div>
            <common-store-list :compact="true" :only-with-goods="true"></common-store-list>
          </section>

          <div class="empty-manufacturer-products" v-if="!manufacturerSamples.length">
            <i class="iconfont">&#xe610;</i>
            <strong>Find the right manufacturer</strong>
            <p>Search stores, compare suppliers, and send inquiries from store pages.</p>
          </div>
        </div>
      </section>

      <div class="copyright">
        <div v-if="config"><a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{config.wab_number}}</a></div>
        <div v-if="config"><a href="https://beian.miit.gov.cn" target="_blank">{{config.icp_number}}</a></div>
        <div v-if="config">{{config.flow_static_code}}</div>
      </div>

      <div class="modal-mask" :class="{ show: showModal && voucher_list && voucher_list.length > 0 }" @click.self="closeModal">
        <div class="modal-container">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title">Voucher List</h2>
            </div>
            <div class="coupons-container">
              <div class="coupon" v-for="(item, index) in voucher_list" :key="index">
                <div class="coupon-title">{{item.vouchertemplate_storename}}</div>
                <div class="coupon-value">${{item.vouchertemplate_price}}</div>
                <div class="coupon-desc">{{item.vouchertemplate_title}}</div>
                <button class="get-btn" @click="receiveVoucher(item.vouchertemplate_id, index)" v-if="item.is_have == 0">Receive</button>
                <button class="get-btn received" @click="receiveVoucher(item.vouchertemplate_id, index)" v-else>Received</button>
              </div>
            </div>
          </div>
          <button class="close-btn iconfont" @click="closeModal">&#xe69a;</button>
        </div>
      </div>

      <div class="voucher_btn" @click="openModal" v-if="voucher_list && voucher_list.length > 0"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Indicator, Toast } from 'mint-ui'
import SpecialIndex from '../special/Index'
import IndexProductList from './IndexProductList'
import IndexSeckillList from './IndexSeckillList'
import IndexProductScroll from './IndexProductScroll'
import IndexBanner from './IndexBanner'
import IndexMenu from './IndexMenu'
import IndexFloorAds from './IndexFloorAds'
import CommonStoreList from '../common/CommonStoreList'
import { loadScript } from '../../../util/common'
import $ from 'jquery'
import { getVoucherList } from '@/api/homeindex'
import { receiveVoucher } from '@/api/homestoredetail'
import { getStoreClass } from '@/api/seller'
import { searchGoodsList } from '@/api/homesearch'

export default {
  name: 'HomeIndex',
  data () {
    return {
      uniapp: 0,
      isIos: false,
      isAndroid: false,
      isshowBacktop: true,
      popular: '',
      sale: 'goods_salenum',
      recently: 'goods_addtime',
      showModal: false,
      voucher_list: [],
      activeHomeTab: 'products',
      sampleProducts: [],
      productActions: [
        { title: 'Source by category', icon: '&#xe61d;', routeName: 'HomeGoodsclass', color: 'blue' },
        { title: 'Top ranking', iconClass: 'trophy-icon', routeName: 'HomeTopRanking', color: 'red' }
      ],
      manufacturerCategories: []
    }
  },
  components: {
    SpecialIndex,
    IndexProductList,
    IndexSeckillList,
    IndexProductScroll,
    IndexBanner,
    IndexMenu,
    IndexFloorAds,
    CommonStoreList
  },
  mounted () {
  },
  created: function () {
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isAndroid) {
      this.isAndroid = true
    }
    if (isIOS) {
      this.isIOS = true
    }
    let _this = this
    loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
      uni.getEnv(function (res) {
        _this.ifLoaded = true
        if (res.plus) {
          _this.uniapp = 1
        } else {
          if (isAndroid) {
            $('.android_app').show()
          }
          if (isIOS) {
            $('.ios_app').show()
          }
        }
      })
    })
    this.fetchHomeAd({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeArticle({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeProduct({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.loadSampleProducts()
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.getVoucherList()
    this.getManufacturerCategories()
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      banners: state => state.home.banners,
      navs: state => state.home.navs,
      floorAds: state => state.home.floorAds,
      articles: state => state.home.articles,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts,
      goodProducts: state => state.home.goodProducts,
      goodSeckill: state => state.home.goodSeckill,
      user: state => state.member.info
    }),
    manufacturerSamples () {
      return this.sampleProducts
    }
  },
  methods: {
    ...mapActions({
      fetchHomeAd: 'fetchHomeAd',
      fetchHomeArticle: 'fetchHomeArticle',
      fetchHomeProduct: 'fetchHomeProduct',
      fetchConfig: 'fetchConfig'
    }),
    goRoute (name, query, params) {
      this.$router.push({ name: name, query: query || {}, params: params || {} })
    },
    goKeyword (keyword) {
      this.$router.push({ name: 'HomeGoodslist', query: { keywords: keyword } })
    },
    goStoreKeyword (keyword) {
      this.$router.push({ name: 'HomeStorelist', query: keyword ? { keywords: keyword } : {} })
    },
    getManufacturerCategories () {
      getStoreClass().then(res => {
        const storeClasses = res && res.result && Array.isArray(res.result.store_class)
          ? res.result.store_class
          : []
        this.manufacturerCategories = [
          { id: '', title: 'All', active: true },
          ...storeClasses.map(item => ({
            id: item.storeclass_id,
            title: item.storeclass_name,
            active: false
          }))
        ]
      }).catch(() => {
        this.manufacturerCategories = [{ id: '', title: 'All', active: true }]
      })
    },
    loadSampleProducts () {
      searchGoodsList({
        is_sample: 1,
        sort_key: 'goods_salenum',
        page: 1,
        per_page: 6
      }, this.$store.state.member.token).then(res => {
        const goodsList = res && res.result && Array.isArray(res.result.goods_list)
          ? res.result.goods_list
          : []
        this.sampleProducts = goodsList.filter(item => {
          return item.is_sample_support == 1 && parseFloat(item.sample_price) > 0
        }).slice(0, 6)
      }).catch(() => {
        this.sampleProducts = []
      })
    },
    goStoreCategory (storeclassId) {
      this.$router.push({
        name: 'HomeStorelist',
        query: storeclassId ? { storeclass_id: storeclassId } : {}
      })
    },
    goGoodsDetail (goodsId) {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goodsId } })
    },
    closeModal () {
      this.showModal = false
    },
    openModal () {
      this.showModal = true
    },
    getVoucherList () {
      var userId = 0
      if (this.user) {
        userId = this.user.member_id
      }
      Indicator.open()
      getVoucherList(userId).then(res => {
        Indicator.close()
        this.voucher_list = res.result.voucher_list
        var showModal = this.utils.fetch('show_modal')
        if (this.voucher_list && this.voucher_list.length > 0 && showModal != 1) {
          this.showModal = true
          this.utils.save('show_modal', 1)
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
    receiveVoucher (tid, index) {
      receiveVoucher(
        tid
      ).then((res) => {
        Toast(res.message)
        this.voucher_list[index].is_have = 1
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.b2b-home {
  background: #f3f4f6;
  min-height: 100%;
  padding-bottom: 0.8rem;
}
.home-hero {
  background: #fff;
}
.hero-banner {
  overflow: hidden;
  background: #fff;
}
.hero-fallback {
  height: 9.4rem;
  display: flex;
  align-items: flex-end;
  padding: 0.8rem;
  box-sizing: border-box;
  background: linear-gradient(135deg, #14213d, #006d77 54%, #f2a65a);
}
.hero-copy {
  color: #fff;
}
.hero-copy span {
  display: block;
  font-size: 0.58rem;
  opacity: 0.86;
}
.hero-copy strong {
  display: block;
  max-width: 13rem;
  font-size: 1.08rem;
  line-height: 1.35rem;
  margin-top: 0.2rem;
}
.channel-shell {
  position: relative;
  margin-top: -0.55rem;
  padding-top: 0.5rem;
  border-radius: 0.72rem 0.72rem 0 0;
  background: #fff;
  overflow: hidden;
  z-index: 5;
}
.channel-tabs {
  display: flex;
  align-items: flex-end;
  gap: 1.35rem;
  height: 2.6rem;
  padding: 0 0.65rem;
  background: #fff;
  box-sizing: border-box;
}
.channel-tabs button {
  position: relative;
  height: 2.1rem;
  border: 0;
  background: transparent;
  color: #111827;
  font-size: 0.72rem;
  line-height: 2rem;
  font-weight: 700;
}
.channel-tabs button.active {
  font-size: 0.95rem;
}
.channel-tabs button.active:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0.05rem;
  height: 0.16rem;
  border-radius: 0.16rem;
  background: #e93b3d;
}
.tab-panel {
  background: #f3f4f6;
}
.product-search-wrap {
  background: #fff;
  overflow: hidden;
}
.channel-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 2.25rem;
  margin: 0.35rem 0.55rem 0.6rem;
  padding-left: 0.65rem;
  border: 0.1rem solid #20242a;
  border-radius: 0.5rem;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
}
.channel-search span {
  min-width: 0;
  color: #303846;
  font-size: 0.68rem;
  line-height: 1rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.channel-search i {
  display: block;
  flex-shrink: 0;
}
.channel-search .search-submit {
  width: 2.2rem;
  height: 2.05rem;
  line-height: 2.05rem;
  text-align: center;
  color: #fff;
  background: #20242a;
  font-size: 1.08rem;
}
.manufacturer-search {
  border-color: #e93b3d;
}
.manufacturer-search .search-submit {
  background: #e93b3d;
}
.manufacturer-cats,
.sample-scroll {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.manufacturer-cats::-webkit-scrollbar,
.sample-scroll::-webkit-scrollbar {
  display: none;
}
.action-scroll {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.35rem;
  padding: 0 0.55rem 0.65rem;
  background: #fff;
  overflow: hidden;
}
.action-card {
  display: flex;
  align-items: center;
  min-width: 0;
  height: 2.65rem;
  padding: 0 0.35rem;
  border-radius: 0.22rem;
  background: #f7f8fa;
  border: 1px solid #eef0f3;
  box-sizing: border-box;
}
.action-card i {
  position: relative;
  width: 1.45rem;
  height: 1.45rem;
  line-height: 1.45rem;
  margin-right: 0.35rem;
  border-radius: 0.28rem;
  color: #fff;
  text-align: center;
  flex-shrink: 0;
}
.action-card .trophy-icon:before {
  content: "";
  position: absolute;
  left: 50%;
  top: 0.32rem;
  width: 0.52rem;
  height: 0.44rem;
  transform: translateX(-50%);
  border-radius: 0.08rem 0.08rem 0.18rem 0.18rem;
  background: #fff;
  box-shadow:
    -0.24rem 0.05rem 0 -0.1rem #fff,
    0.24rem 0.05rem 0 -0.1rem #fff;
}
.action-card .trophy-icon:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 0.8rem;
  width: 0.58rem;
  height: 0.36rem;
  transform: translateX(-50%);
  background:
    linear-gradient(#fff, #fff) center top / 0.1rem 0.2rem no-repeat,
    linear-gradient(#fff, #fff) center 0.2rem / 0.34rem 0.09rem no-repeat,
    linear-gradient(#fff, #fff) center bottom / 0.52rem 0.1rem no-repeat;
}
.action-card strong {
  min-width: 0;
  color: #151b24;
  font-size: 0.58rem;
  line-height: 0.74rem;
  font-weight: 700;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.manufacturer-cats span {
  height: 1.55rem;
  line-height: 1.55rem;
  padding: 0 0.65rem;
  border-radius: 0.78rem;
  background: #f1f3f5;
  color: #4d5662;
  font-size: 0.62rem;
  white-space: nowrap;
  flex-shrink: 0;
}
.manufacturer-cats {
  gap: 0.95rem;
  padding: 0 0.65rem 0.65rem;
  background: #fff;
}
.manufacturer-search-area {
  background: #fff;
}
.manufacturer-cats span {
  position: relative;
  padding: 0;
  border-radius: 0;
  background: transparent;
  color: #69717d;
  font-size: 0.68rem;
}
.manufacturer-cats span.active {
  color: #111827;
  font-weight: 700;
}
.manufacturer-cats span.active:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.18rem;
  height: 0.12rem;
  border-radius: 0.12rem;
  background: #17202a;
}
.manufacturer-section {
  margin-top: 0.45rem;
  padding: 0.65rem 0 0.7rem;
  background: #fff;
}
.sample-scroll {
  gap: 0.35rem;
  padding: 0 0.55rem;
}
.sample-card {
  width: 5.45rem;
  min-width: 5.45rem;
  color: #17202a;
}
.sample-card img {
  width: 5.45rem;
  height: 5.45rem;
  border-radius: 0.22rem;
  object-fit: contain;
  background: #f6f7f9;
}
.sample-card span {
  display: block;
  margin-top: 0.35rem;
  color: #7a8491;
  font-size: 0.56rem;
  line-height: 0.76rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.sample-card strong {
  display: block;
  color: #111827;
  font-size: 0.78rem;
  line-height: 1rem;
  font-weight: 700;
}
.factory-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.45rem;
  padding: 0 0.55rem;
}
.factory-card,
.empty-manufacturer-products {
  min-width: 0;
  padding: 0.65rem;
  border-radius: 0.32rem;
  background: #f7f9fb;
  box-sizing: border-box;
}
.factory-card i,
.empty-manufacturer-products i {
  display: block;
  width: 1.55rem;
  height: 1.55rem;
  line-height: 1.55rem;
  margin-bottom: 0.38rem;
  border-radius: 0.28rem;
  color: #fff;
  text-align: center;
}
.factory-card strong,
.empty-manufacturer-products strong,
.supplier-entry strong {
  display: block;
  font-weight: 700;
  font-size: 0.72rem;
  line-height: 1rem;
}
.factory-card p,
.empty-manufacturer-products p,
.supplier-entry p {
  margin-top: 0.12rem;
  font-size: 0.56rem;
  line-height: 0.82rem;
  color: #64707d;
}
.empty-manufacturer-products {
  margin: 0.45rem 0.55rem 0;
  text-align: left;
}
.blue {
  background: #2563eb;
}
.green {
  background: #16805c;
}
.orange {
  background: #e93b3d;
}
.red {
  background: #c2410c;
}
.industry-section {
  margin-top: 0.45rem;
  background: #fff;
  padding: 0.65rem 0.55rem;
}
.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.55rem;
}
.manufacturer-section .section-title {
  padding: 0 0.55rem;
}
.section-title span,
.supplier-entry span {
  display: block;
  color: #8a5a16;
  font-size: 0.52rem;
  line-height: 0.75rem;
}
.section-title strong {
  display: block;
  color: #17202a;
  font-size: 0.76rem;
  font-weight: 700;
  line-height: 1rem;
}
.section-title button,
.supplier-entry button {
  border: 0;
  background: #17202a;
  color: #fff;
  height: 1.35rem;
  line-height: 1.35rem;
  min-width: 2.8rem;
  border-radius: 0.18rem;
  font-size: 0.56rem;
}
.industry-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.45rem;
}
.industry-card {
  min-height: 4.3rem;
  padding: 0.55rem;
  border-radius: 0.3rem;
  box-sizing: border-box;
  background: #f7f9fb;
  border: 1px solid #edf0f3;
}
.industry-icon {
  display: block;
  width: 1.35rem;
  height: 1.35rem;
  line-height: 1.35rem;
  text-align: center;
  color: #fff;
  background: #31572c;
  border-radius: 0.22rem;
  margin-bottom: 0.35rem;
}
.industry-card:nth-child(2n) .industry-icon {
  background: #1d4e89;
}
.industry-card:nth-child(3n) .industry-icon {
  background: #b24c2f;
}
.supplier-entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  padding: 0.75rem 0.55rem;
  margin-top: 0.45rem;
  background: #fff;
  box-sizing: border-box;
}
.supplier-entry div {
  min-width: 0;
}
.supplier-entry strong {
  font-size: 0.74rem;
}
.copyright {
  font-size: .65rem;
  color: #999;
  text-align: center;
  padding: .6rem 0 .2rem;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(9, 13, 20, 0.72);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.25s ease;
  pointer-events: none;
  padding: 0 16px;
  box-sizing: border-box;
}
.modal-mask.show {
  opacity: 1;
  pointer-events: auto;
}
.modal-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  background: white;
  border-radius: 0.4rem;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  transform: scale(0.96);
  transition: transform 0.25s ease;
  max-height: 95vh;
  overflow-y: auto;
}
.modal-mask.show .modal-container {
  transform: scale(1);
}
.modal-content {
  padding: 0.5rem 0.4rem;
  position: relative;
  z-index: 20;
  background: white;
}
.modal-header {
  text-align: center;
  margin-bottom: 1.2rem;
}
.modal-title {
  font-size: 1rem;
  color: #17202a;
  margin-bottom: 12px;
  position: relative;
  font-weight: 700;
}
.modal-title:after {
  content: "";
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: #c2410c;
  border-radius: 2px;
}
.coupons-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
}
.coupon {
  background: linear-gradient(135deg, #b91c1c, #f59e0b);
  border-radius: 0.35rem;
  padding: 0.5rem;
  text-align: center;
  color: white;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  position: relative;
  overflow: hidden;
  z-index: 10;
}
.coupon-title {
  line-height: 1.2rem;
  max-height: 2.4rem;
  font-size: 1rem;
  overflow: hidden;
}
.coupon-value {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 0.2rem;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
.coupon-desc {
  font-size: 0.6rem;
  margin-top: 0.2rem;
}
.get-btn {
  background: rgba(255, 255, 255, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: white;
  padding: 0.3rem 0.4rem;
  border-radius: 0.22rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 600;
  font-size: 0.64rem;
  min-width: 5rem;
  margin-top: 0.4rem;
}
.get-btn.received {
  opacity: 0.72;
}
.get-btn:active {
  transform: scale(0.95);
}
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: #edf0f3;
  border: none;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  color: #666;
  transition: all 0.3s ease;
  z-index: 30;
  box-shadow: 0 3px 10px rgba(0,0,0,0.1);
}
.close-btn:active {
  transform: scale(0.9) rotate(90deg);
}
.voucher_btn {
  width: 1.4rem;
  height: 1.4rem;
  position: fixed;
  right: 0.6rem;
  bottom: 3.2rem;
  background: url(../../../assets/image/voucher.png);
  background-size: cover;
  z-index: 50;
}
.floor-ad {
  margin-top: 0.45rem;
  margin-bottom: 0;
  background: #fff;
}
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
a,
button {
  touch-action: manipulation;
}
@media (min-width: 400px) {
  .coupons-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 600px;
  }
  .modal-title {
    font-size: 1.46rem;
  }
  .coupon {
    padding: 25px;
  }
  .coupon-value {
    font-size: 1.46rem;
  }
}
@media (min-width: 992px) {
  .modal-container {
    max-width: 800px;
  }
  .coupons-container {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
